import { useState, useEffect } from 'react';

const navLinks = [
  { label: 'Sobre', href: '#sobre' },
  { label: 'Áreas de Atuação', href: '#areas' },
  { label: 'Diferenciais', href: '#diferenciais' },
  { label: 'Contato', href: '#contato' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNav = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setMobileOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-deep/95 backdrop-blur-md border-b border-gold/10'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between h-28">
        {/* Logo */}
        <a href="#" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }} className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/bfd915e00effedbd3630bc37231affe4.png"
            alt="Benner Martins Advocacia"
            className="h-[110px] lg:h-[92px] w-auto object-contain"
          />
        </a>

        {/* Desktop Menu */}
        <ul className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                onClick={(e) => handleNav(e, link.href)}
                className="text-ice/80 hover:text-gold font-sans text-sm font-400 tracking-wide transition-colors duration-300 relative group whitespace-nowrap cursor-pointer"
              >
                {link.label}
                <span className="absolute -bottom-1 left-0 w-0 h-px bg-gold transition-all duration-300 group-hover:w-full" />
              </a>
            </li>
          ))}
        </ul>

        {/* CTA Button */}
        <a
          href="https://wa.me/5598981578332?text=Olá,%20gostaria%20de%20falar%20com%20um%20advogado."
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="hidden lg:flex items-center gap-2 bg-gold hover:bg-gold-light text-deep font-sans font-600 text-sm px-6 py-3 rounded-md transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-whatsapp-line text-base" />
          Fale com um Advogado
        </a>

        {/* Mobile Toggle */}
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="lg:hidden w-10 h-10 flex items-center justify-center text-ice cursor-pointer"
          aria-label="Menu"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="lg:hidden bg-deep/98 backdrop-blur-md border-t border-gold/10 px-6 py-6 flex flex-col gap-5">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => handleNav(e, link.href)}
              className="text-ice/80 hover:text-gold font-sans text-base transition-colors duration-300 cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href="https://wa.me/5598981578332?text=Olá,%20gostaria%20de%20falar%20com%20um%20advogado."
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="flex items-center justify-center gap-2 bg-gold text-deep font-sans font-600 text-sm px-6 py-3 rounded-md mt-2 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-base" />
            Fale com um Advogado
          </a>
        </div>
      )}
    </nav>
  );
}
